export default function isAPISupported(api) {
  return typeof window !== 'undefined' ? api in window : false;
}

